// Fixed paper palette for standalone report SVGs (see docs/UI_DESIGN.md).
// Explicit SVG attributes make downloads independent of application styles.
export const researchFigureTheme = {
  paper: '#fff',
  ink: '#17243d',
  axis: '#657184',
  grid: '#e0e3e6',
  series: ['#244b9b', '#ad4432', '#277451', '#76539b', '#986500', '#146d7c'],
};
